import React, { useState } from "react";

const LogoUpload = ({register, setValue, errors}) => {
  const [logo, setLogo] = useState(null);
  const [fileName, setFileName] = useState("");

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 4 * 1024 * 1024) {
        alert("File size exceeds 4MB!");
        return;
      }
      setLogo(URL.createObjectURL(file));
      setFileName(file.name);

        // ✅ Set form value for validation
        setValue("agencyLogo", e.target.files);
    }
  };

  const handleRemoveLogo = () => {
    setLogo(null);
    setFileName("");
    setValue("logo", null);
  };

  return (
    <div className="d-flex flex-column align-items-center p-1 border rounded bg-light" style={{maxWidth:"240px"}}>
      {/* Logo Preview */}
      <div
        className="rounded-circle overflow-hidden d-flex justify-content-center align-items-center"
        style={{ width: "40px", height: "40px", backgroundColor: "#000" }}
      >
        {logo ? (
          <img src={logo} alt="Logo Preview" className="w-100 h-100 object-fit-cover" />
        ) : (
          <span className="text-white fw-bold">{fileName}</span> // Replace with default logo if needed
        )}
      </div>

      {/* Upload Button & Remove Button */}
      <div className="mt-1 d-flex align-items-center">
        <label className="btn btn-dark btn-sm me-2">
          Upload Agency Logo
          <input type="file" accept="image/*" className="d-none" onChange={handleLogoChange} ref={register("agencyLogo").ref}/>
        </label>
        {logo && (
          <button className="button save" onClick={handleRemoveLogo}>
            Remove
          </button>
        )}
      </div>

       {/* Validation Error Message */}
   {errors.agencyLogo && <p className="text-danger">{errors.agencyLogo.message}</p>}

      {/* File Size Info */}
      <small className="text-muted mt-2">Image formats with max size of 4 MB</small>
    </div>
  );
};

export default LogoUpload;
